import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import { useParams } from 'react-router-dom';
import CreditCardTransactionInfo from './CreditCardTransactionInfo';
import useFetchCreditCardTransaction from '../../hooks/useApi/useFetchCreditCardTransaction';
import useAccountBearer from '@/hooks/useApi/useAccountBearer';

type FC = FunctionComponent<vp.TransactionIdAndType>;

const CreditCardTransactionContainer: FC = (props: vp.TransactionIdAndType) => {
  const { TransactionID, Type } = props;
  const { accountId } = useParams<{ accountId: string }>();
  const token = useAccountBearer(accountId);
  const [CreditCardTransaction, getCreditCardTransaction] = useFetchCreditCardTransaction({
    bearer: token,
  });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.CreditCardTransactionResponse>();
  useEffect(() => {
    if (!token) return;
    if (Type === vp.TransactionType.CREDIT_CARD) {
      getCreditCardTransaction(TransactionID);
    }
  }, [currentTransactionId, token]);

  useEffect(() => {
    if (CreditCardTransaction) {
      setTransaction(CreditCardTransaction);
    }
  }, [CreditCardTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return <div>{transaction && <CreditCardTransactionInfo transaction={transaction} />}</div>;
};

export default CreditCardTransactionContainer;
